import React from 'react';
import inEU from '@segment/in-eu';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Typography,
    FormControl,
    RadioGroup,
    Radio
} from '@mui/material';
import { withStyles } from 'tss-react/mui';
import DialogCloseButton from '../../buttons/DialogCloseButton';
import { AnalyticsConsentStatuses, setAnalyticsConsentStatus } from '../../../utilities/analyticsUtilities';

const styles = theme => ({
    dialogTitle: {
        [theme.breakpoints.down('xl')]: {
            display: 'flex',
            justifyContent: "space-between"
        }
    },
    questionText:{
        color: "rgba(255, 255, 255, 0.7)" 
    }
});

class ConsentDialog extends React.Component {
    state = {
        consentStatus: AnalyticsConsentStatuses.UNTRACKED
    }

    render() {
        const { classes, open } = this.props;
        const { consentStatus } = this.state;

        return (
            <Dialog
                open={open}
                onClose={this.handleClose}
                maxWidth='xs'
                fullWidth={true}
                aria-labelledby='consent-dialog-title'
            >
                <DialogTitle id='consent-dialog-title'>
                    <div className={classes.dialogTitle}>
                        Data Collection Preferences
                        <DialogCloseButton
                            onClick={this.handleClose}
                        />
                    </div>
                </DialogTitle>
                <DialogContent>
                    <Typography
                        variant='body2'
                    >
                        We use data collected by cookies and JavaScript libraries to improve your browsing experience, analyze site traffic, and increase the overall performance of our site.
                    </Typography>
                    <br/>
                    <Typography className={classes.questionText}>Do you allow us to collect analytics data about your usage of Specterr using Plausible Analytics and Amplitude?</Typography>
                    <FormControl variant="standard" component='fieldset'>
                        <RadioGroup aria-label='consent status' name='consentStatus' value={consentStatus} onChange={this.handleConsentStatusChange}>
                            <FormControlLabel value={AnalyticsConsentStatuses.OPTIN} control={<Radio />} label='Yes' />
                            <FormControlLabel value={AnalyticsConsentStatuses.OPTOUT} control={<Radio />} label='No' />
                        </RadioGroup>
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <div style={{flex: '1 0 0'}} />
                    <Button
                        onClick={() => this.handleSave()}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    handleClose = () => {
        const { onClose } = this.props;

        // close without preferences saved
        onClose(false);
    };

    handleSave = () => {
        const { onClose } = this.props;
        const { consentStatus } = this.state;

        setAnalyticsConsentStatus(consentStatus, inEU())

        // close with preferences saved
        onClose(true);
    }

    handleConsentStatusChange = (event) => {
        this.setState({consentStatus: event.target.value});
    }
}

export default withStyles(ConsentDialog, styles);